import React from "react";

interface OrganizationNotFoundProps {
  title: string;
  description?: string;
}

const OrganizationNotFound: React.FC<OrganizationNotFoundProps> = ({ title, description }) => (
  <div className="flex h-64 items-center justify-center text-center" role="status">
    <div>
      <h2 className="text-2xl font-bold text-primary">{title}</h2>
      {description && <p className="mt-2 text-lg">{description}</p>}
    </div>
  </div>
);

export default OrganizationNotFound;
